import(/* webpackMode: "eager" */ "/codebuild/output/src2456823074/src/ui-directo/apps/backoffice/src/app/error.tsx");
